import React from 'react';
import { Container } from './styled';

const Table: React.FC = ({ children }) => <Container>{children}</Container>;

export default Table;
